var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 20,
    width: 95,
    height: 100,
    rx: 40,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120 89C120 106.121 106.121 120 89 120L51 120C33.8792 120 20 106.121 20 89L20 60C20 37.9086 37.9086 20 60 20L89 20C106.121 20 120 33.8792 120 51L120 89ZM89 111C101.15 111 111 101.15 111 89L111 51C111 38.8497 101.15 29 89 29L60 29C42.8792 29 29 42.8792 29 60L29 89C29 101.15 38.8497 111 51 111L89 111Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 31C0 13.8792 13.8792 0 31 0H69C86.1208 0 100 13.8792 100 31V60C100 82.0914 82.0914 100 60 100H31C13.8792 100 0 86.1208 0 69V31ZM60 91C77.1208 91 91 77.1208 91 60C91 42.8792 77.1208 29 60 29C42.8792 29 29 42.8792 29 60C29 77.1208 42.8792 91 60 91Z",
    fill: "#134E90"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60 41.25C64.6041 41.25 68.3333 44.9792 68.3333 49.5833C68.3333 54.1875 64.6041 57.9167 60 57.9167C55.3958 57.9167 51.6666 54.1875 51.6666 49.5833C51.6666 44.9792 55.3958 41.25 60 41.25ZM68.3333 63.2083C68.3333 65.4167 67.75 70.5625 63.7708 76.3125L62.0833 66.25L64.0416 62.3333C62.75 62.1875 61.3958 62.0833 60 62.0833C58.6041 62.0833 57.25 62.1875 55.9583 62.3333L57.9166 66.25L56.2291 76.3125C52.25 70.5625 51.6666 65.4167 51.6666 63.2083C46.6875 64.6667 43.3333 67.2917 43.3333 70.4167V78.75H76.6666V70.4167C76.6666 67.2917 73.3333 64.6667 68.3333 63.2083Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSite);
export default __webpack_public_path__ + "static/media/icon_site.84b8492b128d49f2d136511b2c32cf23.svg";
export { ForwardRef as ReactComponent };